import _ from 'lodash';
import { SCREEN_SIZE__MUTATE_SCREEN, SCREEN_SIZE__UPDATE_SCREEN } from '@/store/types';

const createInitialState = () => {
  return {
    mobile: false,
    tablet: false,
    desktop: false,
  };
};

export const mutations = {
  [SCREEN_SIZE__MUTATE_SCREEN](state, payload) {
    const sizes = ['mobile', 'tablet', 'desktop'];

    _.forEach(sizes, (value) => {
      state[value] = value === payload.screenSizeType;
    });
  },
};

export const actions = {
  [SCREEN_SIZE__UPDATE_SCREEN]({ commit }, screenSizeType) {
    commit(SCREEN_SIZE__MUTATE_SCREEN, { screenSizeType });
  },
};

export const getters = {};

export const screenSize = {
  state: createInitialState,
  mutations,
  actions,
  getters,
};
